import React, { useEffect } from 'react';
import Routes from './Routes';

function App() {
  useEffect(() => {
    // Enable dark mode by default
    document.documentElement?.classList?.add('dark');
  }, []);

  return <Routes />;
}

export default App;
